
//LOGIN
export const POST_LOGIN = "/api/login";
export const UPDATE_PASSWORD = "/api/usersPassword/";
export const POST_USER_PREFS = "api/usersprefs/";
export const POST_USER_BAN = "api/usersBan/";

//USERS
export const GET_USER = "/api/users";
export const GET_USER_CUSTOMER = "/api/usersCustomer";
export const POST_USER = "/api/users/";
export const GET_USER_KPI = "api/usersKpi";
export const GET_USER_KPI_CUSTOMER = "api/usersKpiCustomers";

export const NEW_PASSWORD = "/api/usersNewPassword/";
export const VALID_NEW_PASSWORD = "/api/usersValidNewPwd/";
export const UPDATE_PWD = "/api/usersUpdatePwd";

export const REGISTER_USER = "/api/usersRegister";
export const ACTIVATE_ACCOUNT = "/api/usersActivateAccount/";

export const VERIFY_USER = "/api/usersVerify/";
export const ACTIVATE_USER = "/api/usersActivate/";

export const RESEND_EMAIL_ACTIVATION = "/api/usersResendActivationEmail/"
export const SEND_EMAIL_ADMIN = "/api/usersSendEmailAdmin"

//SECTOR
export const GET_SECTOR = "/api/sectors";
export const POST_SECTOR = "/api/sectors/";

//GROUPS
export const GET_GROUP = "/api/groups";
export const POST_GROUP = "/api/groups/";
export const GET_GROUP_KPI = "api/groupsKpi";

//COMMENTS
export const GET_COMMENT = "/api/comments";
export const POST_COMMENT = "/api/comments/";

//PROJECTS
export const GET_PROJECTS = "/api/projects";
export const POST_PROJECT = "/api/projects/";

//PRODUCTS
export const GET_PRODUCTS = "/api/products";
export const POST_PRODUCT = "/api/products/";

//COMPONENTS
export const GET_COMPONENTS = "/api/brands";
export const POST_COMPONENT = "/api/brands/";

//BRANDS
export const GET_BRANDS = "/api/brands";
export const POST_BRAND = "/api/brands/";

//COMPONENTS
export const GET_CATEGORIES = "/api/categories";
export const POST_CATEGORY = "/api/categories/";

//RELEASE
export const GET_RELEASE = "/api/releases";
export const POST_RELEASE = "/api/releases/";

//RELEASE NOTES
export const GET_RELEASE_NOTES = "/api/releaseNotes";
export const POST_RELEASE_NOTES = "/api/releaseNotes/";

//NOTIFICATIONS
export const GET_NOTIFICATIONS = "/api/notifs";
export const GET_NOTIFICATIONS_RELEASE = "/api/notifsRelease";
export const POST_NOTIFICATIONS = "/api/notifs/";

//DOCUMENTS
export const POST_PRICE_DOCUMENT = "/api/productsUpdatePrices/";
export const POST_DOCUMENT = '/api/upload/'

//CONFIGURATIONS
export const GET_CONFIGURATIONS = "/api/configurations";
export const POST_CONFIGURATION = "/api/configurations/";
export const DUPLICATE_CONFIGURATION = "/api/configurations/duplicate/";
export const CHECK_CONFIGURATION = "/api/configurations/editConfigurator/";
export const VERIFY_CONFIGURATION = "/api/configurations/validate/"; // to change 
export const CHECK_CONFIGURATIONS_EXPIRED = "/api/configurations/updateStatus/";

//QUOTES
export const QUOTE_TO_PDF = "/api/quoteGeneratePdf/"
export const CREATE_QUOTE = "/api/quote/"

//AGENCIES
export const GET_AGENCIES = "/api/agencies";
export const POST_AGENCY = "/api/agencies/";

//DEPARTMENTS
export const GET_DEPARTMENTS = "/api/departments";
export const POST_DEPARTMENT = "/api/departments/";

//LINES
export const GET_LINES = "/api/lines";
export const POST_LINE = "/api/lines/";

//DASHBOARD
export const GET_DASHBOARD = "/api/dashboard";


